import { render, staticRenderFns } from "./CadastroClienteModal.vue?vue&type=template&id=c4665d38&"
import script from "./CadastroClienteModal.vue?vue&type=script&lang=js&"
export * from "./CadastroClienteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports